import {
  CommentsPinboardTeaserBreakpoint,
  CommentsPinboardTeaserConfig as ICommentsPinboardTeaserConfig
} from 'services/api-service'

export class CommentsPinboardTeaserConfig implements ICommentsPinboardTeaserConfig {
  constructor(config: ICommentsPinboardTeaserConfig) {
    this.activeOnly = config.activeOnly
    this.breakpointsConfig = config.breakpointsConfig
    this.commentMaxLength = config.commentMaxLength
    this.hoverTitleMaxLength = config.hoverTitleMaxLength
    this.includeSyndicated = config.includeSyndicated
    this.maxDaysOld = config.maxDaysOld
    this.promoButtonUrl = config.promoButtonUrl
    this.showReviewStars = config.showReviewStars
    this.titleMaxLength = config.titleMaxLength
    this.userNameMaxLength = config.userNameMaxLength
    this.widgetDivId = config.widgetDivId
  }

  activeOnly: boolean
  breakpointsConfig: Array<CommentsPinboardTeaserBreakpoint>
  commentMaxLength: number
  hoverTitleMaxLength: number // product title shown over product/media image
  includeSyndicated: boolean
  maxDaysOld: number
  promoButtonUrl: string
  showReviewStars: boolean // displays over product/media image
  titleMaxLength: number // product title shown below product image
  userNameMaxLength: number
  widgetDivId: string
}

let defaultConfig: ICommentsPinboardTeaserConfig = {}
export function loadConfig(config: ICommentsPinboardTeaserConfig): void {
  defaultConfig = new CommentsPinboardTeaserConfig(config)
}
export { defaultConfig as default }
